module.exports = __webpack_public_path__ + "static/img/5.ac9308ae.png";